// import { canUseDOM } from 'exenv';

export function giftGuideLoading(resp = {}, store = {}) {
  return {
    type: 'GIFT_GUIDE_LOADING',
    giftGuide: resp,
    store
  };
}

export function giftGuideLoaded(resp = {}, store = {}, year) {
  return {
    type: 'GIFT_GUIDE_LOADED',
    giftGuide: resp,
    store,
    year
  };
}

export function giftGuideLoadError(error, store = {}) {
  return {
    type: 'GIFT_GUIDE_ERROR',
    giftGuide: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store
  };
}
